<template>
    <div id="netgsm-channel-detail">
        <AppBreadCrumb
            :paths="[{ title: $t('whatsappChannel.netgsmDetail') }]"
            :select="true"
            class="visitor-detail-bread-crumb"
        >
        </AppBreadCrumb>
        <div class="wrapper">
            <div class="toolbar">
                <div class="left">
                    <IconButton :on-click="() => $router.push('/integrations/sms/netgsm')">
                        <span class="material-icons"> chevron_left </span>
                    </IconButton>
                    <div class="icon-container">
                        <img src="/static/img/netgsm-logo.svg" />
                    </div>
                    <div class="name">Netgsm</div>
                </div>
            </div>
            <div class="channel-content">
                <div class="left">
                    <ChannelMenu v-model="currentTab" />
                </div>
                <div class="page-content" v-if="channel">
                    <div v-if="currentTab === NetgsmChannelMenuTypes.CHANNEL.id">
                        <UpdateDetail v-model="channel" :credit="credit" />
                    </div>
                    <div v-if="currentTab === NetgsmChannelMenuTypes.SEND_SMS.id">
                        <SendSmsNetgsm :channel="channel" :senders="senders" :credit="credit" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AppBreadCrumb from "../../../../../../components/common/AppBreadCrumb.vue";
import IconButton from "../../../../Settings/components/IconButton.vue";
import NetgsmChannelMenuTypes from "./NetgsmChannelMenuTypes";
import UpdateDetail from "./UpdateDetail.vue";
import SendSmsNetgsm from "./SendSmsNetgsm.vue";
import { mapActions, mapState } from "vuex";
import ChannelMenu from "./ChannelMenu.vue";
import _ from "lodash";

export default {
    name: "NetgsmChannelDetail",
    components: {
        ChannelMenu,
        IconButton,
        AppBreadCrumb,
        UpdateDetail,
        SendSmsNetgsm,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "detail").toLowerCase().trim();
        const selected = Object.values(NetgsmChannelMenuTypes).find((x) => x.path === path);
        return {
            currentTab: selected ? selected.id : "detail",
            NetgsmChannelMenuTypes,
            channel: null,
            selectedChannelId: this.$route.params.id,
            senders: [],
            credit: 0,
        };
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels.filter((x) => x.type === "sms-netgsm"),
        }),
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
            getNetgsmChannelSenders: "channel/getNetgsmChannelSenders",
            getNetgsmChannelCredit: "channel/getNetgsmChannelCredit",
        }),
    },
    mounted() {
        this.getNetgsmChannelSenders(this.selectedChannelId)
            .then((data) => {
                this.senders = _.get(data, "list", []);
            })
            .catch(() => {});
        this.getNetgsmChannelCredit(this.selectedChannelId)
            .then((data) => {
                this.credit = data;
            })
            .catch(() => {});
        this.listChannels().then((channels) => {
            this.channel = channels.find((x) => x._id === this.selectedChannelId);
        });
    },
    watch: {
        currentTab(value) {
            const selected = Object.values(NetgsmChannelMenuTypes).find((x) => x.id === value);
            if (selected) {
                this.$router.push(`/integrations/sms/netgsm/${this.$route.params.id}/detail/${selected.path}`);
            }
        },
    },
};
</script>
<style scoped lang="scss">
#netgsm-channel-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .toolbar {
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            border: 1px solid var(--color-border-default);

            .left {
                display: flex;
                align-items: center;
                gap: 5px;

                .name {
                    font-size: 18px;
                    font-weight: 700;
                }

                .icon-container {
                    width: 100px;
                    height: 30px;
                    display: flex;
                    margin: 0 auto;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    overflow: hidden;
                    padding: 10px;
                }
            }
        }

        .channel-content {
            display: flex;
            height: 100%;

            .left {
                width: 275px;
                height: 100%;
            }

            .page-content {
                width: calc(100% - 275px);
                height: 100%;
            }
        }
    }
}
</style>
